<template>
  <v-card width="800px" :outlined="true">
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <b>{{item.by.split('@')[0]}}</b>
        </v-col>
        <v-col cols="2"/>
        <v-col cols="4" align-self="end" >
          {{datetime}}
        </v-col>
      </v-row>
      <v-divider class="my-5" />
      <v-row >
        <v-card-text>
          {{item.description}}
        </v-card-text>
      </v-row>
    </v-card-text>
    <!--<v-row v-if="username === item.by">
      <v-card-actions>
        <v-btn 
          color="success"
          @click.stop="editFeedback"
        >
          Editar
        </v-btn>
      </v-card-actions>
    -->  
  </v-card>
</template>
<script>
export default {
  props:{
    item:{
      type:Object,
      default: function() {
        return {
          id:undefined,
          by:"",
          timestamp:"",
          description:""
        }
      }
    },
  },
  computed:{
    username(){
      if(this.oidcIsAuthenticated){
        return this.oidcUser.name
      } else {
        return "none"
      }
    },
    datetime(){
      return (new Date(this.item.timestamp + "Z")).toLocaleString()
    }

  },
  methods:{
    editFeedback(){
      this.$cf_api.editProjectFeedback(this.item.id, {description: this.item.description}).then(()=>{})
    }
  }
}
</script>